import { IconActivity } from './IconActivity';
import { IconChart } from './IconChart';
import { IconChecklist } from './IconChecklist';
import { IconDefault } from './IconDefault';
import { IconFlask } from './IconFlask';
import { IconInProgress } from './IconInProgress';
import { IconLightBulb } from './IconLightBulb';
import { IconMessage } from './IconMessage';
import { IconPlug } from './IconPlug';
import { IconRocket } from './IconRocket';
import { IconSearch } from './IconSearch';
import { IconSettings } from './IconSettings';
import { IconUpdate } from './IconUpdate';
import { IconUser } from './IconUser';
import { IconWarning } from './IconWarning';
import IconSpotDefault from './SpotDefault';

export const Illustration = {
	IconActivity,
	IconChart,
	IconChecklist,
	IconDefault,
	IconFlask,
	IconLightBulb,
	IconMessage,
	IconPlug,
	IconRocket,
	IconSearch,
	IconSettings,
	IconSpotDefault,
	IconUser,
	IconWarning,
	IconInProgress,
	IconUpdate,
};
